import { MeetingPage } from '@features/meetings/components/MeetingPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_shell/_ownAccount/activity')({ component: MeetingPage });
